var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.375 6A2.625 2.625 0 013 3.375h11A2.625 2.625 0 0116.625 6v1.797a2.603 2.603 0 012.409-.177l3 1.286a2.625 2.625 0 011.591 2.413V16c0 1.303-.95 2.385-2.195 2.59a3.126 3.126 0 01-5.846.035H8.416a3.126 3.126 0 01-5.846-.035A2.626 2.626 0 01.375 16V6zm16.25 9a3.125 3.125 0 014.989 2.231c.451-.226.761-.692.761-1.231v-4.681c0-.55-.328-1.047-.833-1.264l-3-1.286a1.375 1.375 0 00-1.917 1.264V15zm-1.25 2.375H8.623a3.125 3.125 0 00-6.237-.144A1.375 1.375 0 011.625 16V6c0-.76.616-1.375 1.375-1.375h11c.76 0 1.375.616 1.375 1.375v11.375zM5.5 15.625a1.875 1.875 0 100 3.75 1.875 1.875 0 000-3.75zM16.625 17.5a1.875 1.875 0 113.75 0 1.875 1.875 0 01-3.75 0z",
    fill: "currentColor"
  })));
}
export default SvgTruck;